module.exports = __webpack_public_path__ + "img/bf-logo-dark.a7bde54c.png";